import { Link } from '../lib/routing';

export default function NotFound() {
  return (
    <main className="min-h-screen grid place-items-center p-6 text-center">
      <div>
        <h1 className="text-[96px] font-black text-naia-blue">404</h1>
        <p className="text-xl text-muted-foreground">Cette page n'existe pas.</p>
        <Link to="/" className="mt-6 inline-block px-6 py-3 bg-naia-blue text-card rounded-sm font-black shadow-card">
          Retour à l'accueil
        </Link>
      </div>
    </main>
  );
}
